import { useBoardFromContext } from "../../../utils/hooks/commonly-stored/uploaded-board/board";
import {
  Board,
  ManufacturingNotification,
} from "../../../reducers/uploadedBoard";
import {
  FlashPCBTable,
  InputLabel,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../constants/Styles";
import {
  NoNotifications,
  NotificationDetailsContainer,
  NotificationDetailsItem,
} from "./NotificationsStyles";

function notificationTitle(notification: ManufacturingNotification) {
  if (notification.gerber_file_issue !== null) {
    return "Normalized Gerber file may differ from input";
  }
}

function NotificationDetails({
  notification,
}: {
  notification: ManufacturingNotification;
}) {
  if (notification.gerber_file_issue !== null) {
    return (
      <NotificationDetailsContainer>
        <NotificationDetailsItem>
          <InputLabel>Filename</InputLabel>
          <div>{notification.gerber_file_issue.filename}</div>
        </NotificationDetailsItem>
        <NotificationDetailsItem>
          <InputLabel>Diff score</InputLabel>
          <div>
            {notification.gerber_file_issue.diff_score.toLocaleString(
              undefined,
              {
                maximumFractionDigits: 5,
              },
            )}
          </div>
        </NotificationDetailsItem>
        <NotificationDetailsItem>
          <InputLabel>Threshold</InputLabel>
          <div>
            {notification.gerber_file_issue.diff_score_threshold.toLocaleString(
              undefined,
              {
                maximumFractionDigits: 5,
              },
            )}
          </div>
        </NotificationDetailsItem>
      </NotificationDetailsContainer>
    );
  }
}

export default function Notifications() {
  const board = useBoardFromContext().board as Board;

  if (board.manufacturing_details?.notifications.length === 0) {
    return <NoNotifications>No notifications</NoNotifications>;
  }

  return (
    <FlashPCBTable>
      <thead>
        <TableHeaderRow>
          <TableHeaderCell>Notification</TableHeaderCell>
          <TableHeaderCell>Details</TableHeaderCell>
        </TableHeaderRow>
      </thead>
      <tbody>
        {board.manufacturing_details?.notifications.map((notification) => {
          return (
            <TableRow key={JSON.stringify(notification)}>
              <TableCell>{notificationTitle(notification)}</TableCell>
              <TableCell>
                <NotificationDetails notification={notification} />
              </TableCell>
            </TableRow>
          );
        })}
      </tbody>
    </FlashPCBTable>
  );
}
